import type { UseFormRegisterReturn } from 'react-hook-form';
import { SegmentedControl } from '@/components/ui/SegmentedControl';
import { FieldLabel } from '@/components/forms/FieldLabel';
import { TextField } from '@/components/forms/TextField';
import { FIELD_LABELS, FIELD_PLACEHOLDERS, YES_NO_OPTIONS } from '../constants';

export type YesNo = 'yes' | 'no';

export interface LeadInvestorFieldsProps {
  hasLeadInvestor?: YesNo;
  onHasLeadInvestorChange: (next: YesNo) => void;
  /** `register('leadInvestorName')` from the host form. */
  nameInputProps: UseFormRegisterReturn;
  nameError?: string;
}

/**
 * "Do you have a lead investor?" Yes/No, then the lead's name only on Yes
 * (UX sheet r151). Shared by the create wizard and the profile editor.
 */
export function LeadInvestorFields({
  hasLeadInvestor,
  onHasLeadInvestorChange,
  nameInputProps,
  nameError,
}: LeadInvestorFieldsProps) {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-2">
        <FieldLabel label={FIELD_LABELS.hasLeadInvestor} variant="caps" />
        <SegmentedControl
          label={FIELD_LABELS.hasLeadInvestor}
          options={YES_NO_OPTIONS}
          value={hasLeadInvestor}
          onChange={(next) => onHasLeadInvestorChange(next === 'yes' ? 'yes' : 'no')}
        />
      </div>
      {hasLeadInvestor === 'yes' && (
        <TextField
          {...nameInputProps}
          label={FIELD_LABELS.leadInvestorName}
          labelVariant="caps"
          placeholder={FIELD_PLACEHOLDERS.leadInvestorName}
          error={nameError}
        />
      )}
    </div>
  );
}
